import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.svg";

export const frontmatter: BlogFrontmatter = {
  title: "Cyber hygiene for small businesses",
  header: "Cyber hygiene for small businesses",
  date: "2025-05-22",
  description:
    "Simple, everyday security habits that help small businesses reduce cyber risk and meet growing partner expectations.",
  category: "security",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
};
